import { Action } from '@ngrx/store';
import { type } from '../util';

export const ActionTypes = {
  UPDATE_PRICE_MISMATCH: type('[Price] Put Price Mismatch'),
  RESET: type('[Price] Reset')
};

export class UpdatePriceMismatchAction implements Action {
    type = ActionTypes.UPDATE_PRICE_MISMATCH;

  constructor(public payload: any) { }
}

export class ResetAction implements Action {
    type = ActionTypes.RESET;

  constructor(public payload?: any) { }
}

export type Actions = UpdatePriceMismatchAction | ResetAction;
